module.exports = __webpack_public_path__ + "static/media/INVENTORY-COST-OF-GOODS.dc7cdced.svg";